/**
 * CartProvider actions
 */

import {
  CART_CHECK_AND_CONTINUE,
  CART_CHECK_AND_CONTINUE_COMPLETE,
  CART_DELETE_ITEM_REQUEST,
  CART_UPDATE_REWARDS_REQUEST,
} from './constants';

/**
 * Cart check and continue request - start saga
 *
 * @param {string} nextPagePath The redirect path if check is successful
 * @returns {object} An action object with a type of CART_CHECK_AND_CONTINUE
 */
export function cartCheckAndContinue(currentStep, nextPagePath, values) {
  return {
    type: CART_CHECK_AND_CONTINUE,
    currentStep,
    nextPagePath,
    values,
  };
}

/**
 * Cart check and continue complete
 *
 * @returns {object} An action object with a type of CART_CHECK_AND_CONTINUE_COMPLETE
 */
export function cartCheckAndContinueComplete(message) {
  return {
    type: CART_CHECK_AND_CONTINUE_COMPLETE,
    message,
  };
}

/**
 * Cart item delete request - start the request saga
 *
 * @param {int} cartRewardId The cart reward's ID
 * @returns {object} An action object with a type of CART_DELETE_ITEM_REQUEST
 */
export function cartItemRemoveRequest(cartRewardId) {
  return {
    type: CART_DELETE_ITEM_REQUEST,
    cartRewardId,
  };
}

/**
 * Cart items update request - start the request saga
 *
 * @param {array} values The array cart item of objects
 * @returns {object} An action object with a type of CART_UPDATE_REWARDS_REQUEST
 */
export function cartUpdateRewardsRequest(values) {
  return {
    type: CART_UPDATE_REWARDS_REQUEST,
    values,
  };
}
